<div [ngStyle]="{'height': height}"></div>
